export const UserTokenSet = 'USER_TOKEN_SET'
export const UserInfoSet = 'USER_INFO_SET'
export const UserClear = 'USER_CLEAR'
export const CurrentMenuSet = 'Current_Menu_SET'
export const CurrentSettingClear = 'Current_Setting_Clear'
export const ActiveMoudleChange = 'Active_Moudle_Change'
export const GetMenuPermissions = 'Get_Menu_Permissions'
export const CurrentConfigsSet = 'Current_Configs_SET'
export const SearchInfoSet = 'Search_Info_SET'
export const SearchInfoClear = 'Search_Info_Clear'
export const CurrentTenantSet = 'Current_Tenant_SET'
export const CurrentTenantClear = 'Current_Tenant_Clear'
export const WindowResize = 'WINDOW_RESIZE'
export const ContinueCreateSet = 'ContinueCreate_SET'
export const ContinueCreateClear = 'ContinueCreate_Clear'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js